import React from 'react';
import { Page, Document, Image, StyleSheet, View, Text, Font } from '@react-pdf/renderer';
import InvoiceTitle from './InvoiceTitle'
import BillTo from './BillTo'
import InvoiceNo from './InvoiceNo'
import InvoiceItemsTable from './InvoiceItemsTable'
import InvoiceThankYouMsg from './InvoiceThankYouMsg'

import logo from '../mplLogoNew30-07-24.jpeg'
import footer from '../MPI New Reproting Ietterhead 30-07-2024 Footer.jpeg'

const styles = StyleSheet.create({
  page: {
    paddingTop: 150, paddingBottom: 50,
    fontSize: 7,
    lineHeight: 1.5,
    flexDirection: 'column'
  },
  box: { width: '100%', marginBottom: 30, borderRadius: 5 },
  pageNumbers: {
    position: 'absolute',
    bottom: 20,
    left: 0,
    right: 0,
    textAlign: 'center'
  },
  qrcode: {
    width: 60,
    height: 60
  },
  logo: {
    width: 170,
    height: 90,
    marginLeft:10,
    marginTop:-60

  },
  barcode: {
    width: 150,
    height: 40
  }
});


const CovidTemplate = ({ invoice }) => {

  return (<Page style={styles.page} size="A4" wrap
    >

<Text style={{
                            fontFamily: 'Helvetica-Bold',
                            fontSize: 5,
                            width:"100%",
                            marginTop:10,
                            marginLeft:-10,
                            textAlign:"right",
                            marginBottom: 1,
                            position:"absolute"

                        }}>{"DOC No: MPL-GEN-F026 | Issue No: 01 | Issue Date: 04-01-2021"}</Text>

      <View fixed style={{
        width: '100%', display: 'flex', flexDirection: 'row', top: 0, position: 'absolute',
        paddingLeft: 20,
        alignItems: "center",
        fontFamily: "Calibri Regular",
        paddingRight: 20,
        height: 210,
        paddingTop: 10
      }} >
        <Image style={styles.logo} src={logo} />

        <View style={{ marginLeft: 80, flexDirection: "column" }}>
          <View style={{
            margin: 'auto', 
            width: 100, 
            backgroundColor: '#F2F0F0', 
            borderWidth: 1,
            position:"absolute",
            borderColor: 'black',
            marginTop:-30,
            marginLeft:22
          }}>
            <Text style={{ paddingTop: '3em', paddingLeft: '5em', paddingRight: '5em', textAlign: 'center', fontFamily: 'Helvetica-Bold', fontSize: 9 }}>MPL ID : {invoice.invoice_id}</Text>
          </View>
          <View

            style={{
              marginLeft: 30,
              marginTop: 10
            }}
          >

            <Text style={{
              paddingLeft: 20,
              fontSize: 10,
              marginTop: 10
            }}>Online</Text>
            <Image style={{
              width: 70,
              height: 70,
              marginTop: -5
            }} src={invoice.QR_Code_Online} />
          </View>

        </View>


        <View style={{ marginLeft: 43, marginTop: 5 }}  >
          <Image style={styles.barcode} src={invoice.barcode} />

          <Text style={{
            marginLeft: '5em',
            fontFamily: 'Calibri Bold',
            fontSize: 9,
            marginTop: 5,
            borderBottomColor: 'black',
            borderBottomWidth: 0.3,
          }}>{invoice.toAddress + " " + invoice.name}</Text>
          <Text style={{
            marginLeft: '5em',
            paddingTop: '5em',
            fontSize: 7,
            paddingTop: 5,
            paddingBottom: 2,
            borderBottomColor: 'black',
            borderBottomWidth: 0.3,

          }}>{"Age/Gender    :  " + invoice.age_gender}</Text>
          {
            invoice.passport != ""
              ?
              <Text style={{
                marginLeft: '5em',
                paddingTop: '5em',
                fontSize: 7,
                paddingTop: 5,
                paddingBottom: 2,
                borderBottomColor: 'black',
                borderBottomWidth: 0.3,

              }}>{"Passport No    :  " + invoice.passport}</Text>
              :
              null
          }
          
          {invoice.cnic != "" ?
            <Text style={{
              marginLeft: '5em',
              paddingTop: '5em',
              fontSize: 7,
              paddingTop: 5,
              paddingBottom: 2,
              borderBottomColor: 'black',
              borderBottomWidth: 0.3,

            }}>{"CNIC #              :  " + invoice.cnic}</Text>
            : null
          }
          {
            invoice.ShouldSampleDateTimePrint
              ?
              <View>
                <Text style={{
                  marginLeft: '5em',
                  paddingTop: '5em',
                  fontSize: 7,
                  paddingTop: 5,
                  paddingBottom: 2,
                  borderBottomColor: 'black',
                  borderBottomWidth: 0.3,

                }}>{"Sample Date   :  " + invoice.specimen_date}</Text>
                <Text style={{
                  marginLeft: '5em',
                  paddingTop: '5em',
                  fontSize: 7,
                  paddingTop: 5,
                  paddingBottom: 2,
                  borderBottomColor: 'black',
                  borderBottomWidth: 0.3,

                }}>{"Sample Time   :  " + invoice.specimen_time}</Text>


              </View>
              : null

          }
          <Text style={{
            marginLeft: '5em',
            paddingTop: '5em',
            fontSize: 7,
            paddingTop: 5,
            paddingBottom: 2,
            borderBottomColor: 'black',
            borderBottomWidth: 0.3,

          }}>{"Report Date    :  " + invoice.result_date}</Text>
          <Text style={{
            marginLeft: '5em',
            paddingTop: '5em',
            fontSize: 7,
            paddingTop: 5,
            paddingBottom: 2,
            borderBottomColor: 'black',
            borderBottomWidth: 0.3,

          }}>{"Report Time    :  " + invoice.result_time}</Text>

        </View>


      </View>
      <View style={{ width: '100%', height: '100%', marginTop: -40, paddingRight: 20, paddingLeft: 20 }}

      >

        <InvoiceItemsTable invoice={invoice}
        />
<View style={{
          display: "flex",
          flex: 1,
          width: "100%",
          flexDirection: 'row'
        }}>
             <View
            style={{
              width: "48%"
            }}
          >
           <Text style={{ 
                 
                 textAlign: 'left',
                 fontSize:9,
                 fontFamily:"Helvetica-Bold",
                 paddingLeft:10,
                 marginTop:20
                 
                 }}>{invoice.branch_address}</Text>

          </View>
          <View
            style={{
              width: "22%"
            }}
          ></View>
           
          <View
            style={{
              width: "30%",
              alignItems: "center"
            }}
          >
            <Text style={{
              marginLeft: -4,
              marginTop: 5
            }}>Offline (For Emirates)</Text>
            <Image style={styles.qrcode} src={invoice.QR_Code_Offline} />
          </View>
         
        </View>
      </View>

      

      <View fixed style={{ position: 'absolute', width: '100%', bottom: 0, marginTop: -10 }}>
        
        <View style={{ alignItems: 'flex-end', marginRight: 20, marginBottom: 20 }}>


          <Text style={{ fontSize: 7 }}>User ID : {invoice.user_id}  </Text>
          <Text style={{ color: 'red', bottom: 0, right: 0, fontFamily: 'Calibri Bold' }}>This is a digitally verified Report and does not require any Signature</Text>

        </View>
        <View>
        <Image src={footer} style={{height:100}}/>
        </View>
      </View>
    </Page>
  )
}

export default CovidTemplate